export const ESG_COMPONENT_KEY = 'esg-component';
export const ESG_CATEGORIES_KEY = 'esg-common.esg-categories';
export const ESG_FOCUSES_KEY = 'esg-common.esg-focuses';

export const SUSTAINABILITY_LOCALIZATION = 'sustainabilityTitle';
export const SUSTAINABILITY_FIT_FILTER_CHIP_LOCALIZATION_KEY = 'sustainabilityFitFilterChipTitle';
export const EXCLUDE_CATEGORY_LOCALIZATION_KEY = 'excludeCategory';
export const INCLUDE_CATEGORY_LOCALIZATION_KEY = 'includeCategory';
